/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LoyaltyRequestStatusEnum } from './loyaltyRequestStatusEnum';


/**
 * Добавить комментарий к заявке в ПЛ.
 */
export interface LoyaltyRequestChangeDtoAdd { 
    /**
     * время обновления заявки.
     */
    changeDate?: string;
    /**
     * комментарий к обновлению.
     */
    changeText?: string;
    /**
     * ID заявки Unions.Infrastructure.EF.LoyaltyRequest.
     */
    requestId?: string;
    status?: LoyaltyRequestStatusEnum;
}
export namespace LoyaltyRequestChangeDtoAdd {
}


